import React from 'react'
import ExportButton from "./ExportButton/ExportButton"
import {makeStyles} from "@material-ui/core/styles";

const useStyles = makeStyles({
    root:{
        display: 'flex',
        flexDirection: 'row',
        width: 'fit-content',
    }
})

function Buttons({exportQuestionDetails}) {

    const classes = useStyles()

    return (
        <div className={classes.root}>
            <ExportButton exportQuestionDetails={exportQuestionDetails} ></ExportButton>
        </div>
    )
}

export default Buttons
